import styled from "styled-components";
import {PureButton} from "components";

export const SectionWrapper = styled.div`
	background-color: #fff;
	box-shadow: 0px 0.1px 0.3px rgba(28, 28, 30, 0.1), 0px 1px 2px rgba(28, 28, 30, 0.2);
	border-radius: 4px;
	font-family: "Hind", sans-serif;
`;

export const SectionAccordionButton = styled(PureButton)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 14px 20px;
	width: 100%;
	text-align: left;
`;

export const SectionContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px;
`;

export const SectionTitle = styled.div`
	font-size: 16px;
	font-weight: 500;
	margin-bottom: 16px;
	color: ${({theme}) => theme.color.primary};
`;

export const SectionContent = styled.div`
	* {
		color: ${({theme}) => theme.color.primary};
	}

	h1,
	h2,
	h3,
	h4,
	h5 {
		font-size: 16px;
		margin-bottom: 16px;
	}

	ul {
		list-style: disc outside none;
		padding-inline-start: 20px;
	}

	ul,
	p {
		font-size: 14px;
		line-height: 22px;
		margin-bottom: 16px;
	}

	a {
		text-decoration: underline;
	}

	strong {
		font-weight: 500;
	}

	table {
		width: 100%;
		td {
			padding: 20px;
			border: 1px solid;
		}
	}

	@media (max-width: 768px) {
		h1,
		h2,
		h3,
		h4,
		h5 {
			font-size: 14px;
		}
	}
`;
